module.exports = __webpack_public_path__ + "static/media/team-member-4.7971928f.jpeg";